<template>
    <v-dialog :value="dialog" max-width="1300px" persistent @keydown.esc="chiudiDialogMat()">
        <v-card>
            <v-card-title class="headline">
                Gestione materiale in ingresso
                <v-spacer />
                <v-btn icon @click="chiudiDialogMat()">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-form ref="form" v-model="formValid">
                    <v-container fluid>
                        <v-row>
                            <v-col cols="6" sm="6" md="6">
                                <v-text-field label="Fornitore" v-model="elemento.fornitore" :rules="[rules.required]"
                                    dense />
                            </v-col>
                            <v-col cols="3" sm="6" md="3">
                                <v-text-field label="DDT" v-model="elemento.nBolla" :rules="[rules.ddtOrFattura]"
                                    dense />
                                <v-text-field v-model="elemento.dataBolla" type="date" dense outlined class="mt-2"
                                    color="primary" label="Data DDT" />
                            </v-col>
                            <v-col cols="3" sm="6" md="3">
                                <v-text-field label="Fattura" v-model="elemento.nFattura" :rules="[rules.ddtOrFattura]"
                                    dense />
                                <v-text-field v-model="elemento.dataFattura" type="date" dense outlined class="mt-2"
                                    color="primary" label="Data Fattura" />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="4" :md="isLegno ? 4 : 6">
                                <v-select label="Gruppo di prodotto" v-model="elemento.gruppoCategoriaFSC"
                                    :items="gruppiInput"
                                    :item-text="item => item.codGruppo + ' - ' + item.traduzione" item-value="codGruppo"
                                    return-object :rules="[rules.gruppo]" dense />
                            </v-col>
                            <v-col v-if="isLegno" cols="12" sm="4" md="4">
                                <v-autocomplete :items="essenzeItems" label="Essenza" v-model="elemento.essenza"
                                    :rules="[rules.required]" dense />
                            </v-col>
                            <v-col cols="12" sm="4" :md="isLegno ? 4 : 6">
                                <v-select label="Dichiarazione FSC" v-model="elemento.dichiarazioneFSC"
                                    :items="dichiarazioniFSC" item-text="descrizione" item-value="idDichiarazione"
                                    return-object :rules="[rules.dichiarazione]" dense />
                            </v-col>
                        </v-row>

                        <v-row v-if="isCartone">
                            <v-col cols="12" sm="4" md="4">
                                <v-text-field label="Codice di acquisto" v-model="elemento.codiceAcquisto" dense />
                            </v-col>
                            <v-col cols="12" sm="8" md="8">
                                <v-text-field label="Dettaglio prodotto" v-model="elemento.dettaglioProdotto"
                                    hint="Formato fogli, es. 866x1971" persistent-hint dense />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="4" md="2">
                                <v-autocomplete :items="umItems" label="Unità Misura" v-model="elemento.um" dense
                                    :rules="[rules.required]" />
                            </v-col>
                            <v-col v-if="isCartone" cols="12" sm="4" md="3">
                                <v-text-field label="Quantità fogli da DDT" v-model.number="elemento.qtaDDT"
                                    type="number" min="0" step="any" dense />
                            </v-col>
                            <v-col cols="12" sm="4" :md="isCartone ? 4 : 3">
                                <v-text-field :label="labelQta" v-model.number="elemento.qta" type="number" min="0"
                                    step="any" dense :rules="[rules.qtaPositiva]" :hint="hintQta"
                                    :persistent-hint="!!hintQta" />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field label="Descrizione" v-model="elemento.descrizione" hide-details />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-btn icon color="error" @click="eliminaMatPrima()"
                    :disabled="!(elemento.idMateriale > 0) || salvataggioInCorso">
                    <v-icon>delete</v-icon>
                </v-btn>
                <v-spacer />
                <v-btn @click="chiudiDialogMat()" text>Annulla</v-btn>
                <v-btn color="primary" @click="salva" :disabled="salvataggioInCorso" :loading="salvataggioInCorso">
                    Salva
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { set_materiale, del_materiale } from '@/api/api.registroSintesiPers.js'
import { get_gruppi_prodotto, get_dichiarazioni, get_um, get_essenze } from '@/api/api.registroSintesi.js'

export default {
    props: {
        dialog: { type: Boolean, default: false },
        compCode: { type: String, default: '' },
        variante: { type: String, default: '' },
        editItem: { type: Object, default: () => ({}) },
    },

    data() {
        return {
            elemento: {},
            formValid: false,
            salvataggioInCorso: false,

            gruppiProdotto: [],
            dichiarazioniFSC: [],
            um: [],
            essenze: [],

            rules: {
                required: v => !!v || 'Campo obbligatorio',
                // I select con return-object hanno come valore un oggetto: va controllata la chiave, non l'oggetto
                gruppo: v => !!(v && v.codGruppo) || 'Campo obbligatorio',
                dichiarazione: v => !!(v && v.idDichiarazione > 0) || 'Campo obbligatorio',
                qtaPositiva: v => {
                    if (v === null || v === undefined || v === '') return 'Campo obbligatorio';
                    return Number(v) > 0 || 'La quantità deve essere maggiore di zero';
                },
                ddtOrFattura: v => {
                    // Almeno uno tra DDT e Fattura deve essere compilato
                    if (this.elemento.nBolla || this.elemento.nFattura) {
                        return true;
                    }
                    return 'Inserire almeno DDT o Fattura';
                },
            }
        }
    },

    methods: {
        chiudiDialogMat(salva = false) {
            this.$emit("close", salva);
        },

        // Copia l'elemento ricevuto dal padre: tutti i campi devono esistere subito per essere reattivi
        inizializza(sorgente) {
            const el = {
                companyCode: this.compCode,
                idMateriale: -1,
                fornitore: '',
                nBolla: '',
                dataBolla: null,
                nFattura: '',
                dataFattura: null,
                gruppoCategoriaFSC: null,
                dichiarazioneFSC: null,
                essenza: '',
                um: '',
                qta: null,
                qtaDDT: null,
                codiceAcquisto: '',
                dettaglioProdotto: '',
                descrizione: '',
                ...sorgente
            };

            if (!el.companyCode) el.companyCode = this.compCode;
            if (!(el.idMateriale > 0)) el.idMateriale = -1;

            ['fornitore', 'nBolla', 'nFattura', 'essenza', 'um', 'codiceAcquisto', 'dettaglioProdotto', 'descrizione'].forEach(campo => {
                if (el[campo] === null || el[campo] === undefined) el[campo] = '';
            });

            el.dataBolla = el.dataBolla ? String(el.dataBolla).substring(0, 10) : null;
            el.dataFattura = el.dataFattura ? String(el.dataFattura).substring(0, 10) : null;

            // Dal server un gruppo/dichiarazione non valorizzato arriva come oggetto vuoto
            if (!el.gruppoCategoriaFSC || !el.gruppoCategoriaFSC.codGruppo) el.gruppoCategoriaFSC = null;
            if (!el.dichiarazioneFSC || !(el.dichiarazioneFSC.idDichiarazione > 0)) el.dichiarazioneFSC = null;

            if (!(el.qta > 0)) el.qta = null;
            if (el.qtaDDT === undefined || el.qtaDDT === '') el.qtaDDT = null;

            if (!el.um && el.idMateriale <= 0) el.um = this.umPredefinita;

            this.elemento = el;
        },

        async salva() {
            // Validazione form
            if (!this.$refs.form.validate()) {
                this.$toast.alert("Compilare tutti i campi obbligatori");
                return;
            }

            // Validazione aggiuntiva: almeno uno tra DDT e Fattura
            if (!this.elemento.nBolla && !this.elemento.nFattura) {
                this.$toast.alert("Inserire almeno il numero DDT o il numero Fattura");
                return;
            }

            this.salvataggioInCorso = true;

            try {
                const res = await set_materiale(this.preparaDati());

                if (res.data === "OK") {
                    this.chiudiDialogMat(true);
                } else {
                    this.$toast.error("Errore durante il salvataggio: " + res.data);
                }
            } catch (error) {
                console.error("Errore durante il salvataggio:", error);
                this.$toast.error("Errore durante il salvataggio del materiale");
            } finally {
                this.salvataggioInCorso = false;
            }
        },

        // Dati da inviare al server: date vuote e quantità facoltative normalizzate a null
        preparaDati() {
            const dati = { ...this.elemento };
            dati.companyCode = this.compCode || dati.companyCode;
            if (dati.dataBolla === "") dati.dataBolla = null;
            if (dati.dataFattura === "") dati.dataFattura = null;
            dati.qta = Number(dati.qta);
            dati.qtaDDT = (dati.qtaDDT === "" || dati.qtaDDT === null || dati.qtaDDT === undefined) ? null : Number(dati.qtaDDT);
            return dati;
        },

        async caricaDati() {
            try {
                let par = "";
                if (this.role !== "utente") {
                    par = "?companyCode=" + this.compCode;
                }

                const [gruppiRes, dichiarazioniRes, umRes, essenzeRes] = await Promise.all([
                    get_gruppi_prodotto(par),
                    get_dichiarazioni(par),
                    get_um(),
                    get_essenze()
                ]);

                this.gruppiProdotto = gruppiRes.data;
                this.dichiarazioniFSC = dichiarazioniRes.data;
                this.um = umRes.data;
                this.essenze = essenzeRes.data;
            } catch (error) {
                console.error("Errore durante il caricamento dei dati:", error);
                this.$toast.error("Errore durante il caricamento dei dati");
            }
        },

        async eliminaMatPrima() {
            if (!(this.elemento.idMateriale > 0)) {
                this.$toast.alert("Nessun elemento da eliminare");
                return;
            }

            const confirm = await this.$confirm.open("Elimina", "Eliminare l'elemento corrente?");
            if (!confirm) return;

            this.salvataggioInCorso = true;

            try {
                const res = await del_materiale(this.preparaDati());

                if (res.data === "OK") {
                    this.chiudiDialogMat(true);
                } else {
                    // Il server rifiuta l'eliminazione se il materiale è già stato utilizzato o declassato
                    this.$toast.error("Errore durante l'eliminazione: " + res.data);
                }
            } catch (error) {
                console.error("Errore durante l'eliminazione:", error);
                this.$toast.error("Errore durante l'eliminazione del materiale");
            } finally {
                this.salvataggioInCorso = false;
            }
        },

        // Aggiunge il valore corrente all'elenco se non presente: altrimenti il select non lo mostrerebbe
        conValoreCorrente(elenco, valore) {
            const lista = Array.isArray(elenco) ? elenco : [];
            return valore && !lista.includes(valore) ? [...lista, valore] : lista;
        }
    },

    watch: {
        editItem: {
            handler(newVal) {
                this.inizializza(newVal);
            },
            immediate: true
        },

        dialog: {
            handler(newVal) {
                if (!newVal) return;
                // Riparte sempre dai dati del padre (un'apertura precedente annullata non deve lasciare modifiche)
                this.inizializza(this.editItem);
                this.caricaDati();
                // Reset validazione quando si apre il dialog
                this.$nextTick(() => {
                    this.$refs.form?.resetValidation();
                });
            },
            immediate: true
        }
    },

    computed: {
        role() {
            return this.$store.getters['user/getRole'];
        },

        isLegno() {
            return this.variante === 'LEGNO';
        },

        isCartone() {
            return this.variante === 'CARTONE';
        },

        umPredefinita() {
            return this.isLegno ? 'mc' : (this.isCartone ? 'fogli' : '');
        },

        labelQta() {
            if (this.isLegno) return 'Quantità grezza';
            if (this.isCartone) return 'Quantità fogli considerata';
            return 'Quantità';
        },

        hintQta() {
            return this.isCartone ? 'Quantità effettivamente consegnata: è quella usata per giacenza e consumi' : '';
        },

        // In ingresso si usano solo i gruppi non di sola uscita
        gruppiInput() {
            return (this.gruppiProdotto || []).filter(g => g.inputOutput !== 'O');
        },

        umItems() {
            return this.conValoreCorrente(this.um, this.elemento.um);
        },

        essenzeItems() {
            return this.conValoreCorrente(this.essenze, this.elemento.essenza);
        }
    },
}
</script>
